<template>
  <section style="height: 100%">
    <v-app-bar app color="primary" dark>
      <img :src="require('../assets/logo-novaxs-sm.png')" alt="NovaXS" width="30" />

      <v-toolbar-title class="pl-5">Pedidos</v-toolbar-title>
    </v-app-bar>
    <v-subheader
      class="body-1 font-weight-bolder grey lighten-3"
      style="height: 40px !important"
    >Meus pedidos</v-subheader>
    <v-divider />
    <v-list v-if="visit.products.length > 0">
      <v-list-item v-for="(product, index) in visit.products" :key="'product' + index">
        <v-list-item-content>
          <v-list-item-title
            v-text="
              product.amount +
                'x ' +
                product.name +
                ' - Pedido: ' +
                product.orderID
            "
          />
          <v-list-item-subtitle v-html="product.pdv.name"></v-list-item-subtitle>
          <!--            <v-list-item-subtitle-->
          <!--              v-text="product.description"-->
          <!--            ></v-list-item-subtitle>-->
        </v-list-item-content>
        <v-list-item-action>
          <v-list-item-action-text
            style="text-align: right; color: green"
          >{{ $toBrl(product.price) }}</v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-sheet v-else class="fill-height d-flex align-center justify-center">
      <v-layout column justify-center>
        <v-flex class="d-flex justify-center">
          <v-icon color="grey" size="60">fastfood</v-icon>
        </v-flex>
        <v-flex class="d-flex justify-center">
          <span class="subheading grey--text">Parece que você ainda não fez nenhum pedido</span>
        </v-flex>
      </v-layout>
    </v-sheet>
  </section>
</template>

<script>
import VisitService from "../services/visitService";

export default {
  name: "Orders",
  data() {
    return {
      visit: {
        products: [],
        orders: []
      }
    };
  },
  async mounted() {
    if (localStorage.getItem("onlyDigitalMenu").toString() === "true")
      this.getLocalVisits();
    else await this.getActiveVisitByCardNumber();
  },
  methods: {
    getLocalVisits() {
      this.visit = JSON.parse(localStorage.getItem("order"));
    },
    async getActiveVisitByCardNumber() {
      const res = await new VisitService().getActiveVisitsByID();
      this.visit = res.data || { orders: [] };
      if (this.visit.id === 0) {
        localStorage.removeItem("visit");
        localStorage.removeItem("consumptionCard");
      }
      this.visit.products = [];
      this.visit.orders = this.visit.orders.sort((a, b) => b.id - a.id);
      this.visit.orders.forEach(order => {
        if (order.entries) {
          order.entries.forEach(entry => {
            this.visit.products.push({
              ...entry.product,
              amount: entry.amount,
              price: entry.price,
              pdv: order.pdv,
              orderID: order.id
            });
          });
        }
      });
    }
  }
};
</script>

<style scoped></style>
